import Typography from "typography"

const typography = new Typography({
  baseFontSize: '16px',
  baseLineHeight: 1.375,
  headerFontFamily: ['-apple-system', 'Helvetica Neue', 'Roboto', 'Segoe UI', 'sans-serif'],
  bodyFontFamily: ['-apple-system', 'Helvetica Neue', 'Roboto', 'Segoe UI', 'sans-serif']
})

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js